import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import { KeyTermType } from '@client/graphql/__generated__/types';
import isNil from 'lodash/isNil';
import { PercentageTag } from '~/common/components/PercentageTag';
import { formatToCurrency } from '~/services/document/utils/number';
import { useBuyerOfferAnalysisContext } from '../Context/BuyerOfferAnalysisContext';

export const PurchasePriceCard = () => {
  const { listing, agentKeyTerms } = useBuyerOfferAnalysisContext();

  if (!listing) {
    return (
      <Skeleton
        flexBasis={0}
        flexGrow={1}
        height={{ base: 'auto', xl: '250px' }}
        minWidth={{ base: 'auto', xl: '230px' }}
      />
    );
  }

  const purchasePrice = agentKeyTerms[KeyTermType.PURCHASE_PRICE]?.value;

  const formattedListPrice = formatToCurrency(listing.mlsListing?.listPrice);

  return (
    <Card
      flexBasis={0}
      flexGrow={1}
      height={{ base: 'auto', xl: '250px' }}
      minWidth={{ base: 'auto', xl: '230px' }}
    >
      <CardHeader>
        <Text color="whiteAlpha.600" textAlign="center">
          Purchase Price
        </Text>
      </CardHeader>
      <CardBody py={{ base: 2, xl: 4 }}>
        <Flex direction="column" gap={2} width="100%">
          <Text
            color={purchasePrice ? 'white' : 'whiteAlpha.600'}
            fontSize={{ base: '25px', xl: '40px' }}
            fontWeight="medium"
            textAlign="center"
          >
            {isNil(purchasePrice) ? 'TBD' : formatToCurrency(purchasePrice)}
          </Text>
          {!isNil(purchasePrice) && (
            <Flex justifyContent="center">
              {listing.mlsListing?.listPrice && (
                <PercentageTag
                  compareValue={listing.mlsListing?.listPrice}
                  precision={2}
                  value={purchasePrice}
                />
              )}
            </Flex>
          )}
        </Flex>
      </CardBody>
      <CardFooter>
        <Flex alignItems="center" gap={2} justifyContent="center" width="100%">
          <Text color="whiteAlpha.600" textTransform="uppercase">
            List
          </Text>
          <Text fontWeight="medium">{formattedListPrice}</Text>
        </Flex>
      </CardFooter>
    </Card>
  );
};
